module.exports = __webpack_public_path__ + "static/media/experience.3bf3efbe.svg";